import React from 'react';
import { motion } from 'framer-motion';
export function OriginStory() {
  return <section className="py-20 bg-white" data-id="element-123">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-124">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-125">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-126">
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-charcoal leading-tight mb-6" data-id="element-127">
              We walked away from a great paycheck to build something better.
            </h2>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="space-y-6" data-id="element-128">
            <p className="text-lg text-gray-700 leading-relaxed" data-id="element-129">
              My cofounder, Andres, and I launched NTY after walking away from a
              company where we had built five offices and helped grow sales from
              half a million to four million a month. The results were there,
              but the culture had changed.
            </p>

            <p className="text-lg text-gray-700 leading-relaxed" data-id="element-130">
              It went corporate and decisions started coming down that didn't
              line up with how we wanted to lead. So we walked away.
            </p>

            <p className="text-lg text-gray-700 leading-relaxed" data-id="element-131">
              Next thing we knew, the phone was blowing up. People asking where
              we were going, what we were building. The answer was something
              better:{' '}
              <strong className="text-maroon" data-id="element-132">
                a company built around real accountability, high standards, and
                a team culture that makes you want to show up and win.
              </strong>
            </p>

            <div className="pt-6 flex items-center space-x-4" data-id="element-133">
              <div className="flex -space-x-2" data-id="element-134">
                <div className="w-12 h-12 rounded-full bg-maroon flex items-center justify-center text-white font-bold border-2 border-white" data-id="element-135">
                  B
                </div>
                <div className="w-12 h-12 rounded-full bg-charcoal flex items-center justify-center text-white font-bold border-2 border-white" data-id="element-136">
                  A
                </div>
              </div>
              <div data-id="element-137">
                <div className="font-bold text-charcoal" data-id="element-138">Brock & Andres</div>
                <div className="text-sm text-gray-600" data-id="element-139">Co-Founders</div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}